import { reactive, ref, computed } from '@vue/composition-api'
import * as apiMyLink from '@/api/my-link'

/**
 * マイリンク削除確認
 */
export const getGroup = (props, context) => {
  
  const group1 = reactive({

    id: 0,

    /**
     * 初期表示
     */
    init: () => {
      group1.id = props.myLinkTargetParams.id
    },

    /**
     * 削除ボタンを押下した場合
     */
    onDeleteButtonClicked: () => {

      // マイリンク削除APIをコール
      const params = {}
      params.id = group1.id

      apiMyLink.remove(params)
        .then(response => {
          if (response) {
            const { data } = response

            // 親ウィンドウのマイリンク一覧をリロード
            context.emit('loadMyLink')

            // ウィンドウを閉じる
            context.emit('closeMyLinkDeleteConfirm')
          }
        })
    }

  })

  return group1
}
